import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutModule } from '@angular/cdk/layout';

import { HOST_ROUTES } from './app.routes';

import { ErrorResponseInterceptor } from '@core/interceptors/error-response.interceptor';
import { LoadingInterceptor } from '@core/interceptors/loading.interceptor';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';

import {
  NgxMaskConfig,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import { CookieService } from 'ngx-cookie-service';
import { provideToastr } from 'ngx-toastr';

import { MatPaginatorIntlSpanish } from '@shared/layout/commons/intl/paginator-intl-spanish';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

const maskConfig: Partial<NgxMaskConfig> = { validation: false };

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      HOST_ROUTES,
      withComponentInputBinding(),
      withViewTransitions({ skipInitialTransition: true }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),

    provideHttpClient(
      withFetch(),
      withInterceptors([
        LoadingInterceptor,
        TokenInterceptor,
        ErrorResponseInterceptor,
      ])
    ),

    provideAnimationsAsync(),
    provideAnimations(),

    provideToastr({ timeOut: 4000, preventDuplicates: true }),

    provideEnvironmentNgxMask(maskConfig),
    NgxMaskPipe,

    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: MAT_DATE_FORMATS,

      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },

        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'DD/MM/YYYY',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },

    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlSpanish },

    CookieService,

    importProvidersFrom([BrowserModule, BrowserAnimationsModule, LayoutModule]),
  ],
};
